import { Action } from 'redux';

import IInvestmentSaleTransfer from '~Api/InvestmentSaleTransfer/IInvestmentSaleTransfer';
import InvestmentSaleTransfersActionsEnum from '~InvestmentSaleTransfers/ActionsEnum';
import IHistory from '~Api/Administrator/IHistory';
import IUnallocatedInvestment from '~Api/InvestmentSaleTransfer/IUnallocatedInvestment';
import IInvestorAccountInvestmentTransaction from '~Api/Investor/IInvestorAccountInvestmentTransaction';
import ListSortOrderEnum from '~Api/InvestmentSaleTransfer/ListSortOrderEnum';
import { IInvestmentSaleTransferListSettings } from './List';

export interface IInvestmentSaleTransferGetAction extends Action {
    investmentSaleTransferUuid: string;
}

export function investmentSaleTransferGetAction(investmentSaleTransferUuid: string): IInvestmentSaleTransferGetAction {
    return {
        investmentSaleTransferUuid,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferGet,
    };
}

export interface IInvestmentSaleTransferSendAction extends Action {
    investmentSaleTransferUuid: string;
}

export function investmentSaleTransferSendAction(investmentSaleTransferUuid: string): IInvestmentSaleTransferSendAction {
    return {
        investmentSaleTransferUuid,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferSend,
    };
}

export interface IInvestmentSaleTransferSetAction extends Action {
    investmentSaleTransfer: IInvestmentSaleTransfer;
}

export function investmentSaleTransferSetAction(investmentSaleTransfer: IInvestmentSaleTransfer): IInvestmentSaleTransferSetAction {
    return {
        investmentSaleTransfer,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferSet,
    };
}

export interface IInvestmentSaleTransferHistoriesListAction extends Action {
    investmentSaleTransferUuid: string;
}

export function investmentSaleTransferHistoriesListAction(investmentSaleTransferUuid: string): IInvestmentSaleTransferHistoriesListAction {
    return {
        investmentSaleTransferUuid,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferHistoriesList,
    };
}

export interface IInvestmentSaleTransferHistoriesSetAction extends Action {
    histories: IHistory[];
    investmentSaleTransferUuid: string;
}

export function investmentSaleTransferHistoriesSetAction(investmentSaleTransferUuid: string, histories: IHistory[]): IInvestmentSaleTransferHistoriesSetAction {
    return {
        histories,
        investmentSaleTransferUuid,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferHistoriesSet,
    };
}

export interface IInvestmentSaleTransferInvestorAccountInvestmentTransactionsListAction extends Action {
    investmentSaleTransferUuid: string;
}

export function investmentSaleTransferInvestorAccountInvestmentTransactionsListAction(investmentSaleTransferUuid: string): IInvestmentSaleTransferInvestorAccountInvestmentTransactionsListAction {
    return {
        investmentSaleTransferUuid,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferInvestorAccountInvestmentTransactionsList,
    };
}

export interface IInvestmentSaleTransferInvestorAccountInvestmentTransactionsSetAction extends Action {
    investmentSaleTransferUuid: string;
    investorAccountInvestmentTransactions: IInvestorAccountInvestmentTransaction[];
}

export function investmentSaleTransferInvestorAccountInvestmentTransactionsSetAction(investmentSaleTransferUuid: string, investorAccountInvestmentTransactions: IInvestorAccountInvestmentTransaction[]): IInvestmentSaleTransferInvestorAccountInvestmentTransactionsSetAction {
    return {
        investmentSaleTransferUuid,
        investorAccountInvestmentTransactions,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferInvestorAccountInvestmentTransactionsSet,
    };
}

export interface IInvestmentSaleTransfersAddAction extends Action {
    investmentUuid: string;
    investorAccountInvestmentTransactionsUuids: string[];
}

export function investmentSaleTransfersAddAction(investmentUuid: string, investorAccountInvestmentTransactionsUuids: string[]): IInvestmentSaleTransfersAddAction {
    return {
        investmentUuid,
        investorAccountInvestmentTransactionsUuids,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransfersAdd,
    };
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IInvestmentSaleTransfersUnallocatedInvestmentsListAction extends Action {}

export function investmentSaleTransfersUnallocatedInvestmentsListAction(): IInvestmentSaleTransfersUnallocatedInvestmentsListAction {
    return {
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransfersUnallocatedInvestmentsList,
    };
}

export interface IInvestmentSaleTransfersUnallocatedInvestmentsSetAction extends Action {
    unallocatedInvestments: IUnallocatedInvestment[];
}

export function investmentSaleTransfersUnallocatedInvestmentsSetAction(unallocatedInvestments: IUnallocatedInvestment[]): IInvestmentSaleTransfersUnallocatedInvestmentsSetAction {
    return {
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransfersUnallocatedInvestmentsSet,
        unallocatedInvestments,
    };
}

export interface IInvestmentSaleTransfersPaginatedListAction extends Action {
    order: ListSortOrderEnum;
    orderBy: string;
    page: number;
    perPage: number;
}

export function investmentSaleTransfersPaginatedListAction(
    page: number,
    perPage: number,
    orderBy: string,
    order: ListSortOrderEnum,
): IInvestmentSaleTransfersPaginatedListAction {
    return {
        order,
        orderBy,
        page,
        perPage,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransfersPaginatedList,
    };
}

export interface IInvestmentSaleTransfersPaginatedSetAction extends Action {
    investmentSaleTransfers: IInvestmentSaleTransfer[];
    investmentSaleTransfersPaginatedCount: number;
    page: number;
    perPage: number;
}

export function investmentSaleTransfersPaginatedSetAction(investmentSaleTransfers: IInvestmentSaleTransfer[], investmentSaleTransfersPaginatedCount: number, page: number, perPage: number): IInvestmentSaleTransfersPaginatedSetAction {
    return {
        investmentSaleTransfers,
        investmentSaleTransfersPaginatedCount,
        page,
        perPage,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransfersPaginatedSet,
    };
}

export interface IInvestmentSaleTransferListSettingsSetAction extends Action {
    settings: IInvestmentSaleTransferListSettings;
}

export function investmentSaleTransferListSettingsSetAction(settings: IInvestmentSaleTransferListSettings): IInvestmentSaleTransferListSettingsSetAction {
    return {
        settings,
        type: InvestmentSaleTransfersActionsEnum.InvestmentSaleTransferListSettingsSet,
    };
}